import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { AppMark } from "@/components/AppMark";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      const isPublicRoot = /(^|\.)lxnwrld\.com$/i.test(window.location.hostname);
      navigate(isPublicRoot ? "/wrld" : "/", { replace: true });
    }
    catch (err) { toast.error(err.response?.data?.detail || "Invalid credentials"); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0C] flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-xl bg-[#141416] border border-white/10 flex items-center justify-center text-violet-400">
            <AppMark size={20} />
          </div>
          <div>
            <div className="text-xl font-bold tracking-widest">LXN HQ</div>
            <div className="text-[9px] tracking-[0.5em] text-zinc-600 uppercase mono mt-1">EST. 2026</div>
          </div>
        </div>
        <h1 className="text-3xl font-bold tracking-tight mb-2">Welcome back</h1>
        <p className="text-sm text-zinc-500 mb-8">Sign in to continue.</p>
        <form onSubmit={submit} className="space-y-4" method="post" action="#" name="loginForm">
          <div>
            <label htmlFor="email" className="text-xs text-zinc-400 uppercase tracking-wider">Email</label>
            <Input id="email" name="email" type="email" autoComplete="username" inputMode="email"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="bg-black/40 border-white/10 mt-1" required data-testid="login-email" />
          </div>
          <div>
            <label htmlFor="password" className="text-xs text-zinc-400 uppercase tracking-wider">Password</label>
            <Input id="password" name="password" type="password" autoComplete="current-password"
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="bg-black/40 border-white/10 mt-1" required data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-violet-600 hover:bg-violet-500 rounded-full h-11" data-testid="login-submit">
            {loading ? "Signing in..." : "Log in"}
          </Button>
        </form>
        <div className="mt-6 flex items-center justify-between text-xs">
          <Link to="/register" className="text-violet-400 hover:text-violet-300" data-testid="go-register">Create account</Link>
          <Link to="/recover" className="text-zinc-400 hover:text-zinc-200" data-testid="go-recover">Forgot your password?</Link>
        </div>
      </div>
    </div>
  );
}
